<template>
    <div class="btn-group-toggle" data-toggle="buttons">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'BtnGroupToggle'

};
</script>
